import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import React, { memo } from 'react'

import { LanguageItem, Props as LanguageItemProps } from './LanguageItem'

export interface Props {
  languagesList: LanguageItemProps[]
  languagePrefix: string
}

export const LanguagesMobile = memo(function LanguagesMobile({
  languagesList,
  languagePrefix,
}: Props) {
  return (
    <Container className="lang-mobile" dial={3} row>
      {languagesList.map((item, index) => (
        <LanguageItem currentPrefix={languagePrefix} key={index} {...item} />
      ))}
    </Container>
  )
})

const Container = styled(FlexBox)`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  z-index: 2;
`
